import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker';
import logout from './../../Global/logout';

export default async function GetUserInfo(
) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        await logout()
    }

    return await resolve(
        axios(process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/user/info', {
            method: 'get',
            headers: { 'Authorization' : unHashedJwt}           
        }).then(res => res)
        .catch(error => error)
        );
}